import React from 'react';
import { AlertCircle, CreditCard } from 'lucide-react';
import { useTenant } from './TenantProvider';
import { SUBSCRIPTION_PLANS } from '../lib/stripe';
import { swManager } from '../lib/serviceWorker';
import { useNavigate } from 'react-router-dom';

export default function SubscriptionBanner() {
  const { tenant } = useTenant();
  const navigate = useNavigate();
  const [updateAvailable, setUpdateAvailable] = React.useState(false);

  React.useEffect(() => {
    const handleUpdate = () => setUpdateAvailable(true);
    window.addEventListener('swUpdate', handleUpdate);
    return () => window.removeEventListener('swUpdate', handleUpdate);
  }, []);

  if (!tenant || !tenant.subscription || tenant.subscription?.status === 'active') {
    return null;
  }

  if (updateAvailable) {
    return (
      <div className="bg-indigo-50 border-l-4 border-indigo-400 p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <AlertCircle className="h-5 w-5 text-indigo-400" />
          </div>
          <div className="ml-3">
            <p className="text-sm text-indigo-700">
              A new version is available.
              <button
                onClick={() => swManager.skipWaiting()}
                className="ml-2 font-medium text-indigo-700 underline hover:text-indigo-600"
              >
                Refresh to update
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }

  const handleAction = () => {
    if (tenant.subscription?.status === 'past_due') {
      // Redirect to billing portal
      navigate('/subscription/billing');
    } else {
      // Redirect to plans page
      navigate('/subscription/plans');
    }
  };

  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-yellow-400" />
        </div>
        <div className="ml-3">
          <p className="text-sm text-yellow-700">
            {tenant.subscription?.status === 'past_due' ? (
              <>
                Your subscription payment is past due. Please update your payment method to avoid service interruption.
                <button
                  onClick={handleAction}
                  className="ml-2 inline-flex items-center font-medium text-yellow-700 underline hover:text-yellow-600"
                >
                  <CreditCard className="mr-1 h-4 w-4" />
                  Update Payment
                </button>
              </>
            ) : tenant.subscription?.status === 'cancelled' ? (
              <>
                Your subscription has been cancelled. Choose a new plan to continue using Orange Control.
                <button
                  onClick={handleAction}
                  className="ml-2 inline-flex items-center font-medium text-yellow-700 underline hover:text-yellow-600"
                >
                  <CreditCard className="mr-1 h-4 w-4" />
                  View Plans
                </button>
              </>
            ) : (
              <>
                Please complete your subscription setup to continue using Orange Control.
                <button
                  onClick={handleAction}
                  className="ml-2 inline-flex items-center font-medium text-yellow-700 underline hover:text-yellow-600"
                >
                  <CreditCard className="mr-1 h-4 w-4" />
                  Choose Plan
                </button>
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}